"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var useInfiniteScroll_1 = __importDefault(require("utils/hooks/useInfiniteScroll"));
var ScrollDiv_1 = __importDefault(require("../../Layout/ScrollDiv"));
var NotificationFactory_1 = __importDefault(require("../Types/NotificationFactory"));
var NOTIFICATIONS_PER_PAGE = 5;
var ScrollNotifications = function (_a) {
    var notificationGroups = _a.notificationGroups;
    var _b = __read((0, useInfiniteScroll_1.default)(notificationGroups || [], NOTIFICATIONS_PER_PAGE), 2), notificationsList = _b[0], loaderRef = _b[1];
    return ((0, jsx_runtime_1.jsxs)(ScrollDiv_1.default, { children: [notificationsList === null || notificationsList === void 0 ? void 0 : notificationsList.map(function (_a, idx) {
                var type = _a.type, group = _a.group;
                return ((0, jsx_runtime_1.jsx)(NotificationFactory_1.default, { type: type, notifications: group }, "".concat(type, "-").concat(idx)));
            }), (0, jsx_runtime_1.jsx)("div", { ref: loaderRef })] }));
};
exports.default = ScrollNotifications;
